<template>
  <div class="demoApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="content">
      <div class="top" :style="'background:url('+require('../../assets/demo/group.jpg')+') no-repeat;background-size:cover'">
        <div style="height:38px"></div>
        <div class="use">
          <img class="avatar" :src="userData.avatar" />
          <div class="right">
            <h2>{{userData.username}} </h2>
            <p>
              <span>普通会员</span>
              <font @click="$router.push('citys')"><em class="el-icon-location-outline"></em> {{cityData.length <=0 ? '定位中...' : cityData.cityName}}<em class="el-icon-arrow-right"></em></font>
            </p>
          </div>
        </div>
        <div style="height:30px"></div>
        <div class="nav">
          <a @click="cardHref">
            <img src="~assets/demo/A1.png"/>
            <p>国货精品</p>
          </a>
          <a @click="$router.push('lock')">
            <img src="~assets/demo/A1.png"/>
            <p>共享空间</p>
          </a>
          <a @click="storeCode">
            <img src="~assets/demo/A2.png"/>
            <p>物品租赁</p>
          </a>
          <a @click="$router.push('canteen')">
            <img src="~assets/demo/A3.png"/>
            <p>智慧食堂</p>
          </a>
        </div>
        <div class="banner">
          <swiper :options="swiperOption">
            <swiper-slide class="swiper-slide" v-for="(item,i) in setAdvert">
              <a><img :src="baseUrl+item.banner"></a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div style="height:61px"></div>
      <div class="hot">热门服务</div>
      <ul>
        <li v-for="(item,i) in setMall" @click="toPush(item.id,'detail')">
          <div class="title">
            <img :src="baseUrl+item.logo" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <font>营业时间：{{item.business}}</font>
              <div class="price">星级<i>{{item.star}}</i> 月售:{{item.sale}}<em style="font-style:normal;float:right">距离{{item.distance}}KM</em></div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <div class="footers footCurt" :style="bool == 1 ? 'padding-bottom:22px' : 'padding-bottom:0px'">
      <div class="footer-item on" >
        <img src="~assets/demo/A4.png"/>
        <div>首页</div>
      </div>
      <div class="footer-item" @click="$router.push('parking')">
        <img src="~assets/demo/A6.png"/>
        <div>停车缴费</div>
      </div>
      <div class="footer-item" @click="$router.push('my')">
        <img src="~assets/demo/A5.png"/>
        <div>我的</div>
      </div>

    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        isIphone:false,
        code:'',
        userData:[],
        setAdvert:[],
        setMall:[],
        setRyuser:[],
        cityData:[],
        bool:0
      };
    },
    beforeMount() {
      localStorage.removeItem('user');
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
      window.removeEventListener("resize", this.handleResize);
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/demo');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        if(localStorage.getItem('cCode') == null){
          //this.getQquey();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            //this.getQquey();
          }else{
            this.cityData = cCode;
            this.getMall();
            this.getAdvert();
          }
        }
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            that.fullscreenLoading = true;
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getMall();
                    that.getAdvert();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      cardHref:function(){
        window.location.href="https://ax.v3z.cn/ywJw9g"
      },
      
      storeCode:function(){
        window.location.href="http://user.4008005216.com/main/yunstore"
      },
      ryUser:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/water/wUser',
          params:{
            id:that.userData.id
          }
        }).then(function(response){
          that.setRyuser = response.data.data
        }).catch(err=>{

        });
      },

      getAdvert:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/getAdvert',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setAdvert = data.data
          }
        })

      },
      getMall:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/mallBusiness',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setMall = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          //that.getQquey();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .demoApp{
    max-width:640px;
    background:#222630;
    margin:0 auto;
  }
  .demoApp .content{
    width:100%
  }
  
  .demoApp .content .top{
    width:100%;
    height:372px;
    position: relative;
  }
  .demoApp .content .top .use{
    width:92%;
    margin:0 auto;
    height:80px
  }
  .demoApp .content .top .use img{
    width:74px;
    height:74px;
    border-radius:100%;
    float:left;
    background: rgba(184, 152, 122,0.8);
    padding:3px
  }
  .demoApp .content .top .use .right{
    height:80px;
    float:left;
    margin-left:10px;
    width:calc(100% - 90px)
  }
  .demoApp .content .top .use .right h2{
    color:#fff;
    font-size:28px;
    font-weight: 400;
    margin:8px 0 8px 0
  }
  .demoApp .content .top .use .right p{
    height: 24px;
  }
  .demoApp .content .top .use .right p span{
    float:left;
    border-radius: 2px;
    background: linear-gradient(-45.00deg, rgb(221, 201, 178) 0%,rgb(184, 152, 122) 100%);
    color:#fff;
    width: 80px;
    height: 24px;
    font-size:14px;
    text-align:center;
    line-height: 24px;
  }
  .demoApp .content .top .use .right p font{
    float:right;
    color:#fff;
    font-size:14px;
    line-height: 24px;
  }

  .demoApp .content .top .nav{
    width:92%;
    margin:0 auto;
    border-radius: 4px;
    background: rgba(34, 38, 48,0.8);
  }

  .demoApp .content .top .nav:after,.demoApp .content ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .demoApp .content .top .nav a{
    float:left;
    width:25%;
    padding:15px 0
  }
  .demoApp .content .top .nav a img{
    width:55px;
    display:block;
    margin:0 auto;
    border-radius: 100%;
  }
  .demoApp .content .top .nav a p{
    width:100%;
    text-align:center;
    font-size:16px;
    color: rgb(159, 160, 165);
    padding-top:8px;
    font-weight:bold;
  }
  .demoApp .content .top .banner{
    position: absolute;
    bottom:-65px;
    width:92%;
    left:4%
  }
  .demoApp .content .top .banner img{
    width:100%;
    border-radius: 4px;
    height:150px;
    object-fit: cover;
  }
  .demoApp .content .hot{
    height:80px;
    text-align:center;
    line-height:80px;
    color: rgb(184, 152, 122);
    font-size: 26px;
    font-weight: 400;
  }
  .demoApp .content ul li{
    width:calc(92% - 24px);
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    margin:0 auto 12px auto;
    padding:12px
  }
  .demoApp .content ul li .title{
    position:relative;
    width:100%;
  }
  .demoApp .content ul li .title img{
    float:left;
    width:35%;
    height:100px;
    object-fit: cover;
  }
  .demoApp .content ul li .title .conTitle{
    float:left;
    width:62%;
    margin-left:3%;
    height:100px;
  }
  .demoApp .content ul li .title .conTitle span{
    display:block;
    color: rgb(255, 229, 200);
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:18px;
  }
  .demoApp .content li .title .conTitle font{
    display:block;
    color: rgba(255, 255, 255,0.5);
    font-size:14px;
    padding:18px 0
  }
  .demoApp .content li .title .conTitle .price i{
    color: rgb(255, 194, 127);
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .demoApp .content li .title .conTitle .price b{
    font-size:12px;
  }

  .demoApp .content li .title .conTitle .price{
    font-size: 14px;
    font-family: PingFang SC;
    color: rgba(255, 255, 255,0.5);
  }

  .demoApp .footCurt{
    box-shadow: 0px -4px 30px 0px rgba(0, 0, 0, 0.5);
    background: linear-gradient(180.00deg, rgb(53, 58, 69),rgb(34, 38, 48) 100%);
  }
  .demoApp .footCurt .footer-item{
    font-size:14px;
    color:#96969F
  }
  .demoApp .footCurt .on{
    color: rgb(220, 199, 175);
  }
</style>